import { StyleOptions } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

const defaultStyles = { id: 'sports-highlights-marquee', type: 'theme' } as StyleOptions;
export const HighlightsMarqueeLoader = {
    id: 'highlights-marquee',
    loaderFn: () => import(/* webpackChunkName: "ms-highlights-marquee" */ './highlights-marquee.feature'),
    additionalStylesFn: (): StyleOptions[] | undefined => [defaultStyles],
    product: ClientConfigProductName.SPORTS,
};
